import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store'
import { notification } from "ant-design-vue";
const routes = [
  {
    path: '/',
    redirect: '/index',
    component: () => import('@/views/index/index.vue'),
    children:[
      {
        path: '/index',
        name: 'Index',
        
        component: () => import('@/views/index/index.vue'),
      },]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue')
  },
]

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHashHistory('/template/doctor/index'),
  routes
})
const needlogin = [ '/index']
router.beforeEach((to, from, next) => {
  if (needlogin.includes(to.path)) {
    if (store.state.access_token) {
      next()
    } else {
      // notification.info({message:'登录状态过期，请您重新登录'})
      next('/login')
    }
  } else {
    next()
  }

})
export default router
